import React from 'react'

import cl from './style.module.scss'

const Delimiter: React.FC = () => <div className={cl.splitLine} />

export default Delimiter
